import { makeSelectors } from "../../core/make-selectors";
import { Spine } from "./types";
import { createSelector } from "@reduxjs/toolkit";
import {
  getCfiContentDocIdref,
  safeParseCfi,
} from "../../../../../../common/utils/cfi";

const baseSelectors = makeSelectors<Spine>("spine");

export const getSpine = baseSelectors.getData;

export const getSpineStatus = baseSelectors.getFetchStatus;

export const getSpineIdrefCfis = createSelector(getSpine, (spineData) => {
  return spineData.reduce((result, spineItem) => {
    const cfi = safeParseCfi(spineItem.cfi);
    const idref = getCfiContentDocIdref(spineItem.cfi);
    if (cfi && idref && !result[idref]) {
      result[idref] = cfi.toString();
    }
    return result;
  }, {});
});
